<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">

            <div class="row" v-if="$permissions.hasRight('dashboard.learners.read')">
                <div class="col-lg-6">
                    <members :cohort="cohort" :learners="learners" :instructors="instructors" @change="reload"></members>
                </div>
                <div class="col-lg-6">
                    <registrations :registrations="registrations"></registrations>
                </div>
            </div>
            
            <div class="row" v-else>
                <div class="col-md-12">
                    <registrations :registrations="registrations"></registrations>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
    import Members from './cohort/Members'
    import Registrations from './cohort/Registrations';

    export default {

        components: {
            Members, Registrations
        },

        data() {
            return {
                cohort: {},
                registrations: null,
                learners: null,
                instructors: null,
            }
        },

        computed: {

            breadcrumb() {
                return [{
                    name: this.cohort.name,
                }]
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/dashboard/cohorts/'+to.params.cohortId+'/registrations')
            .then(resp => {
                next(vm => {
                    vm.registrations = resp.data.data
                    vm.cohort = resp.data.included.cohort
                    vm.learners = resp.data.included.learners
                    vm.instructors = resp.data.included.instructors
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        },

        methods: {

            reload() {
                axios.get('/astral/api/front/dashboard/cohorts/'+this.$route.params.cohortId+'/registrations')
                .then(resp => {
                    this.registrations = resp.data.data
                    this.cohort = resp.data.included.cohort
                    this.learners = resp.data.included.learners
                    this.instructors = resp.data.included.instructors
                })
                .catch(err => {
                    this.$auth.handleErrorVm(err, this)
                })        
            }
        }
    }
</script>
